import he from 'he';
import fp from 'lodash/fp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { isMinimumBased } from '../../../../services';
import { currentUserIndustry } from '../../../../state/modules/user';
import { ProgressChart, ProgressWithIcon } from '../../../partials';

export const aoaProgressMap = (aoaTitle, progress) => {
  switch (aoaTitle) {
    case 'Professionalism & Ethics':
      return <span>{progress} minimum CPD Hours</span>
    case 'Technical':
      return <span>{progress} minimum CPD Hours</span>
    case 'Client Care & Practice':
      return <span>{progress} minimum CPD Hours</span>
    case 'Compliance & Consumer Protection':
      return <span>{progress} minimum CPD Hours</span>
    case 'Responsible Managers CPD':
      return <span>{progress} minimum CPD Hours</span>
    case 'General CPD':
      return <span>{progress} minimum CPD Hours</span>
    default:
      return <span>{progress} CPD Hours</span>
  }
}

class CpdCategory extends Component {

  render() {
    const {
      validCpd,
      goTo,
      progress,
      redirectLink,
      title,
      goal,
      isMinimumBased,
      icon,
      shortFall
    } = this.props;

    return (
      <div onClick={(e) => goTo(redirectLink)} className='highlight--areas-of-advice'>
        <h3><span>{title ? he.decode(title) : 'Unknown'}</span></h3>
        {
          isMinimumBased ?
            icon ?
              <ProgressWithIcon {...{
                icon,
                title,
                goal,
                shortFall
              }} /> :
              null :
            <ProgressChart progressPercentage={progress} width={400} height={400} />
        }
        <div className='info'>
          {
            isMinimumBased ?
              shortFall === 0 ?
                <span>Minimum CPD hours met</span> :
                aoaProgressMap(title, `${validCpd}/${goal}`) :
              <span>{validCpd}/{goal} CPD Hours</span>
          }
        </div>
        <div className='earn'>
          {
            shortFall === 0 ?
              <Link to={redirectLink}>Earn Additional CPD</Link> :
              <Link to={redirectLink}>Earn CPD</Link>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  isMinimumBased: isMinimumBased(currentUserIndustry(state))
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ cpdCategorys, cpdCategoryId }) => ({
      icon: fp.flow(
        fp.find(({ id }) => id === cpdCategoryId),
        fp.get('iconUrl')
      )(cpdCategorys)
    })
  )
)(CpdCategory);



// WEBPACK FOOTER //
// ./src/containers/pages/app/dashboard/area-of-advice.js